<template>
  <div class="px-3 pt-3"
       style="border-radius: 15px; border: 1px solid lightgray; background-color: rgba(255, 255, 255, 0.03);"
  >
    <div class="text-center mb-3 font-weight-bold">{{ category.title }}</div>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <div class="overflow-hidden"
             style="border: 1px solid rgba(255,255,255,0.4); border-radius: 5px;"
        >
          <draggable
              draggable=".list-group-item"
              style="min-height: 214px;"
              :group="`choices_${category.id}`"
              :ghost-class="selections.length !== 3 ? 'ghost-item' : ''"
              v-model="selections"
          >
            <template v-for="(selection, index) in selections">
              <v-list-item
                  style="cursor: grab; min-height: 72px;"
                  class="list-group-item"
                  :key="index + '_selection'"
                  :class="index === 0 ? 'first' : index === 1 ? 'second' : 'third'"
              >
                <v-list-item-content>
                  <v-list-item-title class="white--text text-wrap">
                    {{ selection.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template #footer>
              <v-list-item
                  style="min-height: 72px;"
                  :class="placeholder.class"
                  :key="index + '_placeholder'"
                  v-for="(placeholder, index) in filteredPlaceholders">
                <v-list-item-content>
                  <v-list-item-title style="color: rgba(255,255,255,0.6);">
                    <div class="text-center">
                      {{ placeholder.title }}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </draggable>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <div class="fill-height"
             style="border: 1px dashed rgba(255,255,255,0.4); border-radius: 5px;">
          <draggable
              class="fill-height list-group"
              style="min-height: 214px;"
              :group="`choices_${category.id}`"
              :ghost-class="items.length === 0 ? 'ghost-item' : ''"
              v-model="items"
          >
            <template #header>
              <v-row no-gutters justify="center" align="center" class="fill-height" v-if="items.length === 0">
                <v-col cols="auto">
                  <div class="font-italic" style="color: rgba(255,255,255,0.5)">
                    No items remaining
                  </div>
                </v-col>
              </v-row>
            </template>
            <template v-for="(item, index) in items">
              <v-list-item
                  class="list-group-item"
                  style="cursor: grab; min-height: 72px;"
                  :key="index"
              >
                <v-list-item-icon class="ma-0">
                  <v-icon small color="white" class="mt-7">mdi-drag-horizontal-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="white--text text-wrap">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </draggable>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: "ProfitCategoryCard",
  components: {
    draggable,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    filteredPlaceholders() {
      if (this.selections.length > 0) {
        return this.placeholders.filter((_, index) => index > this.selections.length - 1);
      }

      return this.placeholders;
    },
  },
  data: () => ({
    items: [],
    selections: [],
    placeholders: [
      {title: 'First Priority', class: 'first'},
      {title: 'Second Priority', class: 'second'},
      {title: 'Third Priority', class: 'third'},
    ],
  }),
  methods: {
    reset() {
      this.selections = [];
      this.items = JSON.parse(JSON.stringify(this.category.items));
    },
  },
  mounted() {
    this.items = JSON.parse(JSON.stringify(this.category.items));
  },
}
</script>

<style scoped>
.first {
  background-color: rgba(0, 176, 80, 0.4);
}

.second {
  background-color: rgba(254, 152, 0, 0.4);
}

.third {
  background-color: rgba(168, 34, 22, 0.4);
}

.ghost-item {
  display: none;
}
</style>